import script from "./ConfettiBurst.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfettiBurst.vue?vue&type=script&setup=true&lang=js"

import "./ConfettiBurst.vue?vue&type=style&index=0&id=7e50bc52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e50bc52"]])

export default __exports__